document.addEventListener('DOMContentLoaded', () => {
	const btn = document.querySelector('.btn-contact-fixed');
	const faq = document.querySelector('#section-contact');
	const fv = document.querySelector('.section-fv');

	if (!btn || !faq || !fv) return;

	const showBtn = () => {
		btn.style.opacity = '1';
		btn.style.pointerEvents = 'auto';
		btn.style.transform = 'translateY(0)';
	};

	const hideBtn = () => {
		btn.style.opacity = '0';
		btn.style.pointerEvents = 'none';
		btn.style.transform = 'translateY(10px)';
	};

	const toggle = () => {
		const scrollBottom = window.scrollY + window.innerHeight;
		const fvBottom = fv.getBoundingClientRect().bottom;
		const faqTop = faq.getBoundingClientRect().top + window.scrollY;

		if (fvBottom > 0) {
			hideBtn();
			return;
		}

		if (scrollBottom >= faqTop) {
			hideBtn();
		} else {
			showBtn();
		}
	};

	window.addEventListener('scroll', toggle, { passive: true });
	window.addEventListener('resize', toggle);
	toggle();
});
